"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../../../constants/routes");
var constants_1 = require("../../../constants");
var segment_action_summary_1 = require("../../segment_action_summary");
var RETRYABLE_STATUSES = ["failed", "unknown"];
function useRenderCellViews(_a) {
    var can_retry = _a.can_retry, is_retrying = _a.is_retrying, on_retry = _a.on_retry;
    var renderCellViews = (0, react_3.useCallback)(function (run) {
        var _a;
        var status = (0, constants_1.actionRunStatusChip)(run.status);
        return [
            { key: "created_at", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: (0, utils_1.formatDateTime)(new Date(run.created_at)) }) },
            {
                key: "segment_name",
                content: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.SEGMENTS_ROUTE, "/").concat(run.segment_id), className: "text-nowrap text-sm font-medium text-accent hover:underline", children: run.segment_name || run.segment_id })),
            },
            {
                key: "display_name",
                content: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CUSTOMERS_ROUTE, "/").concat(run.user_id), className: "text-nowrap text-sm font-medium text-accent hover:underline", children: run.display_name || run.user_id })),
            },
            {
                key: "type",
                content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-nowrap text-sm font-medium text-default-foreground", children: (0, constants_1.actionTypeLabel)(run.type) }), (0, jsx_runtime_1.jsxs)("span", { className: "text-nowrap text-xs text-muted", children: ["On ", ((_a = constants_1.triggerLabels[run.trigger]) !== null && _a !== void 0 ? _a : run.trigger).toLowerCase(), ": ", (0, jsx_runtime_1.jsx)(segment_action_summary_1.SegmentActionSummary, { type: run.type, params: run.params })] })] })),
            },
            { key: "stint", content: (0, jsx_runtime_1.jsxs)("div", { className: "text-sm text-muted", children: ["#", run.stint] }) },
            {
                key: "status",
                content: ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", color: status.color, children: status.label })),
            },
            { key: "attempts", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm text-muted", children: run.attempts }) },
            {
                key: "last_error",
                content: run.last_error ? ((0, jsx_runtime_1.jsxs)(react_1.Tooltip, { delay: 0, children: [(0, jsx_runtime_1.jsx)(react_1.Tooltip.Trigger, { children: (0, jsx_runtime_1.jsx)("div", { className: "max-w-[220px] truncate text-sm text-danger", children: run.last_error }) }), (0, jsx_runtime_1.jsx)(react_1.Tooltip.Content, { children: run.last_error })] })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-muted", children: "None" })),
            },
            {
                key: "completed_at",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: run.completed_at ? (0, utils_1.formatDateTime)(new Date(run.completed_at)) : "Not yet" }),
            },
            {
                key: "row_actions",
                content: can_retry && RETRYABLE_STATUSES.includes(run.status) ? ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-end", children: (0, jsx_runtime_1.jsxs)(react_1.Button, { size: "sm", variant: "tertiary", isPending: is_retrying, onPress: function () { return on_retry(run); }, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:refresh-linear", width: 16 }), "Retry"] }) })) : null,
            },
        ];
    }, [can_retry, is_retrying, on_retry]);
    return (0, react_3.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
